import { render, staticRenderFns } from "./NewReason.vue?vue&type=template&id=67b0d7c8&"
import script from "./NewReason.vue?vue&type=script&lang=js&"
export * from "./NewReason.vue?vue&type=script&lang=js&"
import style0 from "./NewReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports